// What kind of File a FILES_QUERY row is (server/db/models/file.model.js):
//   'id'    aiq_hhid/aiq_indid, matched to records. Files from before
//           ATAD-136 have no kind and are ID files.
//   'zip'   ATAD-136 — a ZIP code list, used as an audience filter.
//   'model' ATAD-146 — a CMDA model's scores, used as an audience filter.

/**
 * True for matched ID files: the only kind the Uploaded Files list,
 * enhancements and profile reports can use.
 *
 * An allow-list on purpose. These pickers used to exclude ZIP files by name,
 * so each new kind of file leaked into them until someone remembered to add
 * it; anything that isn't an ID file now stays out by default.
 */
export function isIdFile(file: { kind?: string | null } | null | undefined): boolean {
  return !!file && (file.kind == null || file.kind === 'id');
}
